import { addChildAt } from '@ps/bridge/qc/node'
import { Event, EventBus } from '@ps/utils/event-bus'
import store from '@ps/store'
import qc from 'qc'
import { findByUuid } from '@ps/bridge/qc/node/utils'

export type AddNewPrefabActionValue = {
  newValue: {
    node: qc.Node
    parent: qc.Node
    index: number
  }
  oldValue: {
    node: qc.Node
    activeUuid: string
  }
}
export const getAddNewPrefabAction = (value: AddNewPrefabActionValue) => {
  return {
    execute: async ({ newValue }: AddNewPrefabActionValue) => {
      const { node, parent, index, realNode } = newValue
      // 新增节点的时候在 recordHistory 之前已经增加节点了，所以需要判断节点树上是否有该节点
      if (!findByUuid(node.uuid)) {
        addChildAt({
          node,
          parent,
          index,
        })
      }

      EventBus.$emit(Event.ADD_GAME_OBJECT, node.uuid)
      await store.dispatch('workspace/game/updateActiveNode', {
        node: realNode || node,
        record: false,
      })
    },
    undo: ({ oldValue }: AddNewPrefabActionValue) => {
      const { node, activeUuid } = oldValue
      node.removeSelf()
      // 如果undo的时候记录了要激活的节点，则激活该节点
      if (activeUuid) {
        const activeNode = findByUuid(activeUuid)
        activeNode &&
          store.dispatch('workspace/game/updateActiveNode', {
            node: activeNode,
            record: false,
          })
      } else {
        store.dispatch('workspace/game/clearActiveNode', {
          record: false,
        })
      }
    },
    value,
    async: true,
    methodName: 'getAddNewPrefabAction',
  }
}
